import React from 'react'
import UserIcon from '../Icons/UserIcon'

const UserActionButton = ({
  variant = 'outline', // 'outline', 'filled'
  label = 'Ask Human',
  icon: Icon = UserIcon,
  showIcon = true,
  onClick,
  disabled = false,
  className = '',
  type = '',
  config,
  ...props
}) => {
  const handleClick = () => {
    if (disabled) return;
    if (onClick) {
      onClick();
    }
  };

  const isSentType = type === 'sent';
  const isClickable = !isSentType && !disabled;

 
  const getVariantStyles = () => {
    switch (variant) {
      case 'outline':
        return {
          button: `
            bg-[var(--dt-color-surface-100)]
            border-v3-black-inactive
            text-[var(--dt-color-brand-100)]
            border
            hover:border-[var(--dt-color-brand-100)]
          `,
          icon: 'text-[var(--dt-color-brand-100)]',
          text: 'text-[var(--dt-color-brand-100)]'
        };

      case 'filled':
        return {
          button: `
            bg-[var(--dt-color-brand-100)]
            border
            border-[var(--dt-color-brand-100)]
            text-[#FFFFFF]
          `,
          icon: 'text-[#FFFFFF]',
          text: 'text-[#FFFFFF]'
        };

      default:
        return getVariantStyles('outline');
    }
  };

  const styles = getVariantStyles();

  const baseClasses = `
    bubble-user-action-button
    flex
    items-center
    gap-v3-xs
    px-v3-sm
    py-v3-xs
    rounded-v3-xl
    font-medium
    transition-all
    duration-200
    max-w-full
    ${isSentType ? 'flex-wrap' : 'whitespace-nowrap'}
    ${styles.button}
    ${className}
  `;

  if (isSentType) {
    return (
      <div
        className={baseClasses}
        {...props}
      >
        {showIcon && (
          <Icon
            className={`flex-shrink-0 w-5 h-5 ${styles.icon}`}
            stroke="currentColor"
          />
        )}
        <span
          className={`text-v3-h7 ${styles.text} ${isSentType ? 'break-words' : ''}`}
          style={{
            ...(isSentType ? { wordBreak: 'break-word', overflowWrap: 'break-word' } : {}),
            fontSize: config?.font_size ? `${config.font_size}px` : undefined,
            fontFamily: config?.font_name || undefined,
          }}
        >
          {label}
        </span>
      </div>
    );
  }

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`
        ${baseClasses}
        disabled:opacity-50
        disabled:cursor-not-allowed
      `}
      {...props}
    >
      {showIcon && (
        <Icon
          className={`flex-shrink-0 w-5 h-5 ${styles.icon}`}
          stroke="currentColor"
        />
      )}
      <span
        className={`${styles.text} ${isSentType ? 'break-words' : ''}`}
        style={{
          ...(isSentType ? { wordBreak: 'break-word', overflowWrap: 'break-word' } : {}),
          fontSize: config?.font_size ? `${config.font_size}px` : undefined,
          fontFamily: config?.font_name || undefined,
        }}
      >
        {label}
      </span>
    </button>
  )
}

export default UserActionButton